// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__dALoG","mobile":"style_mobile__Cxd3G","laptop":"style_laptop__FcGZg","v3":"style_v3__x+vCK"};